export interface ColorSpec {
  h: number
  c: number
  l: number
}

export interface ThemeSeed {
  id: string
  label: string
  base: ColorSpec
  primary: ColorSpec
  accent: ColorSpec
  mode: "dark" | "light"
}

export const themes = {
  unicorn: {
    id: "unicorn",
    label: "Unicorn",
    mode: "dark",
    base: { h: 260, c: 0.035, l: 0.13 },
    primary: { h: 360, c: 0.15, l: 0.78 },
    accent: { h: 330, c: 0.22, l: 0.65 },
  },
  original: {
    id: "original",
    label: "Simple Dark",
    mode: "dark",
    base: { h: 250, c: 0.025, l: 0.205 },
    primary: { h: 78, c: 0.045, l: 0.79 },
    accent: { h: 72, c: 0.08, l: 0.72 },
  },
  "navy-cyan": {
    id: "navy-cyan",
    label: "Navy / Cyan",
    mode: "dark",
    base: { h: 260, c: 0.035, l: 0.13 },
    primary: { h: 195, c: 0.15, l: 0.78 },
    accent: { h: 330, c: 0.25, l: 0.65 },
  },
} as const satisfies Record<string, ThemeSeed>

export type ThemeId = keyof typeof themes

export const DEFAULT_THEME_ID = Object.keys(themes)[0] as ThemeId
